import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, BookOpenIcon, BarChart3Icon, LifeBuoyIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-20 bg-white overflow-hidden" data-id="element-168">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-169">
        {/* Solution Header */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-170">
          <span className="text-[#1B3A5C] font-bold tracking-wider uppercase text-sm" data-id="element-171">
            La Solución Clínica
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mt-2 mb-4" data-id="element-172">
            MEGA PACK DE INTERVENCIÓN FONOAUDIOLÓGICA INFANTIL™
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8" data-id="element-173">
            Un sistema completo de intervención de 6 meses, diseñado para la
            realidad del consultorio.
          </p>
          <div className="bg-blue-50 inline-block px-6 py-3 rounded-lg border border-blue-100" data-id="element-174">
            <p className="font-medium text-blue-900" data-id="element-175">
              No te dice qué pensar. No reemplaza tu criterio.{' '}
              <span className="font-bold" data-id="element-176">
                👉 Te da una estructura para trabajar con seguridad.
              </span>
            </p>
          </div>
        </motion.div>

        {/* System Details Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-177">
          {/* Card 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#EDF2F7] p-8 rounded-xl border border-blue-100 hover:shadow-lg transition-shadow" data-id="element-178">
            <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-sm mb-6" data-id="element-179">
              <BookOpenIcon className="w-6 h-6 text-[#C9A84C]" data-id="element-180" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-181">
              📘 24 SESIONES LISTAS PARA APLICAR
            </h3>
            <p className="text-sm text-gray-500 mb-4 uppercase tracking-wide font-semibold" data-id="element-182">
              Cada sesión incluye:
            </p>
            <ul className="space-y-2" data-id="element-183">
              {['Objetivo clínico claro', '3 actividades autocontenidas', 'Registro clínico', 'Tarea para casa', 'Adaptaciones para TEA, TDAH y ansiedad'].map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-700 text-sm" data-id="element-184">
                  <CheckIcon className="w-4 h-4 text-[#1B3A5C] mt-0.5 flex-shrink-0" data-id="element-185" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-6 font-bold text-[#1B3A5C] text-sm" data-id="element-186">
              Nada suelto. Nada al azar.
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-[#EDF2F7] p-8 rounded-xl border border-blue-100 hover:shadow-lg transition-shadow" data-id="element-187">
            <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-sm mb-6" data-id="element-188">
              <BarChart3Icon className="w-6 h-6 text-[#C9A84C]" data-id="element-189" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-190">
              📊 SEGUIMIENTO QUE SE VE
            </h3>
            <p className="text-sm text-gray-500 mb-4 uppercase tracking-wide font-semibold" data-id="element-191">
              Planillas organizadas por etapas:
            </p>
            <ul className="space-y-2" data-id="element-192">
              {['Instalación', 'Consolidación', 'Generalización', 'Alta funcional'].map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-700 text-sm" data-id="element-193">
                  <CheckIcon className="w-4 h-4 text-[#1B3A5C] mt-0.5 flex-shrink-0" data-id="element-194" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-6 font-bold text-[#1B3A5C] text-sm" data-id="element-195">
              👉 Pasás de "hacer sesiones" a mostrar proceso.
            </p>
          </motion.div>

          {/* Card 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-[#EDF2F7] p-8 rounded-xl border border-blue-100 hover:shadow-lg transition-shadow" data-id="element-196">
            <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-sm mb-6" data-id="element-197">
              <LifeBuoyIcon className="w-6 h-6 text-[#C9A84C]" data-id="element-198" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-199">
              🧠 SOPORTE CLÍNICO REAL
            </h3>
            <ul className="space-y-2 mb-6" data-id="element-200">
              {['Guía de uso del sistema', 'Criterios de adaptación por perfil', 'Organización del caso clínico', 'Manejo de situaciones difíciles en sesión'].map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-700 text-sm" data-id="element-201">
                  <CheckIcon className="w-4 h-4 text-[#1B3A5C] mt-0.5 flex-shrink-0" data-id="element-202" />
                  {item}
                </li>)}
            </ul>
            <div className="bg-white p-4 rounded-lg border border-gray-100" data-id="element-203">
              <p className="text-xs font-bold text-gray-500 mb-2 uppercase" data-id="element-204">
                Pensado para cuando:
              </p>
              <ul className="space-y-1 text-sm text-gray-600" data-id="element-205">
                <li data-id="element-206">• La sesión no fluye</li>
                <li data-id="element-207">• El niño se desregula</li>
                <li data-id="element-208">• Vos necesitás sostén profesional</li>
              </ul>
            </div>
          </motion.div>
        </div>

        {/* What Changes Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[#1B3A5C] rounded-2xl p-8 md:p-12 text-white" data-id="element-209">
          <h3 className="text-2xl md:text-3xl font-bold text-center mb-10" data-id="element-210">
            ¿QUÉ CAMBIA CUANDO TRABAJÁS ASÍ?
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-211">
            <div className="relative" data-id="element-212">
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#C9A84C] rounded-full" data-id="element-213" />
              <div className="pl-6" data-id="element-214">
                <h4 className="text-xl font-bold mb-4 text-[#C9A84C]" data-id="element-215">
                  En sesión:
                </h4>
                <ul className="space-y-3" data-id="element-216">
                  {['Menos improvisación', 'Más claridad', 'Más seguridad profesional'].map((item, i) => <li key={i} className="flex items-center gap-2 text-lg" data-id="element-217">
                      <CheckIcon className="w-5 h-5 text-[#C9A84C]" data-id="element-218" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>

            <div className="relative" data-id="element-219">
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#C9A84C] rounded-full" data-id="element-220" />
              <div className="pl-6" data-id="element-221">
                <h4 className="text-xl font-bold mb-4 text-[#C9A84C]" data-id="element-222">
                  Fuera de sesión:
                </h4>
                <ul className="space-y-3" data-id="element-223">
                  {['Menos carga mental', 'Menos planificación eterna', 'Más tranquilidad', 'Familias mejor acompañadas'].map((item, i) => <li key={i} className="flex items-center gap-2 text-lg" data-id="element-224">
                      <CheckIcon className="w-5 h-5 text-[#C9A84C]" data-id="element-225" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}